import { render, staticRenderFns } from "./WordInfo.vue?vue&type=template&id=3fd60bef&scoped=true"
import script from "./WordInfo.vue?vue&type=script&lang=js"
export * from "./WordInfo.vue?vue&type=script&lang=js"
import style0 from "./WordInfo.vue?vue&type=style&index=0&id=3fd60bef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd60bef",
  null
  
)

export default component.exports